<template>
  <router-link to="/basket" class="nav-link mob-link">
    My Basket
    <span class="float-right" v-if="$store.state.cartCount">{{$store.state.cartCount}}</span>
    <!-- <span class="float-right" v-if="!$store.state.cartCount">0</span> -->
    <img alt="cart-icon" class="float-right" :src="image_url+'/images/basket.svg'" />
  </router-link>
</template>

<script>
export default {
  name: "shopping-cart",
  data() {
    return {
      image_url: process.env.VUE_APP_S3_IMAGE_URL
    };
  },
  components: {},
  props: ["cart", "total"],
  computed: {
    totalPrice() {
      let total = 0;

      for (let item of this.$store.state.cart) {
        total += item.totalPrice;
      }

      return total.toFixed(2);
    }
  },
  methods: {
    removeFromCart(item) {
      this.$store.commit("removeFromCart", item);
    }
  }
};
</script>
